"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProductUseCase = void 0;
const products_1 = require("@/store/ducks/products");
const products_2 = require("@/services/products");
function createProductUseCase(productName) {
    return (dispatch) => {
        dispatch((0, products_1.updateProduct)());
        return (0, products_2.createProductService)(productName)
            .then((product) => {
            dispatch((0, products_1.updateProductSuccess)());
            return product.id;
        })
            .catch(() => {
            dispatch((0, products_1.updateProductError)());
        });
    };
}
exports.createProductUseCase = createProductUseCase;
exports.default = {
    createProductUseCase,
};
